import * as React from 'react';
import { Id } from '../../utils/ids.js';
import { addClass, Bem } from '../../utils/css.js';
import '../../constants.js';
import './Table.scss.js';

var TableStyle;
(function(TableStyle2) {
  TableStyle2["Plain"] = "plain";
  TableStyle2["Striped"] = "striped";
})(TableStyle || (TableStyle = {}));
const bem = Bem.create("vai-table");
const Table = React.forwardRef(function Table2(props, ref) {
  const {
    component: Component = "table",
    htmlId,
    dataTa = "vai-table",
    condensed = false,
    tableStyle = TableStyle.Striped,
    children,
    useHover,
    className,
    isFullWidth,
    fixedHeader,
    ...rest
  } = props;
  const id = Id.create(htmlId, ["simple table"]);
  const classNames = addClass(bem.block(condensed && "condensed", tableStyle === TableStyle.Striped && tableStyle, useHover && "hover", isFullWidth && "full", fixedHeader && "fixed-header"), className);
  return /* @__PURE__ */ React.createElement(Component, {
    id: id.toString(),
    className: classNames,
    "data-ta": dataTa,
    ...rest,
    ref
  }, children);
});

export { Table, TableStyle };
